import { aQ as l, aN as u, cU as r, al as y, b4 as d, an as c, cV as m, ao as _, t as b, aK as k } from "./value-extraction-C_fDiBaZ.js";
import "vue";
const L = (e) => e !== null && e != null && typeof e == "object" && e.type == "mll", I = (e) => ({
  en: "English",
  nb: "Norwegian (Bokmål)",
  nn: "Norwegian (Nynorsk)",
  se: "Swedish",
  dk: "Danish",
  de: "German"
})[String(e).toLowerCase()] ?? e, h = (e) => ({
  en: "gb",
  nb: "no",
  nn: "no",
  se: "se",
  dk: "dk",
  de: "de"
})[String(e).toLowerCase()] ?? null, v = (e) => {
  e = String(e).toUpperCase();
  const i = 127462, n = 65, a = e.charCodeAt(0) - n + i, s = e.charCodeAt(1) - n + i;
  return String.fromCodePoint(a, s);
}, R = (e) => {
  const i = h(e);
  return i ? v(i) : "❔";
}, z = (e, i, n = void 0) => C(e, i, n), C = (e, i, n, a) => {
  if (L(e)) {
    if (i && e[i] !== void 0)
      return o(e[i], a ?? {});
    const s = Object.keys(e).filter((t) => t != "type")[0] ?? void 0;
    return s ? o(e[s], a ?? {}) : o(n, a ?? {});
  } else if (typeof e != "string" && e !== null && e !== void 0)
    return o(n, a ?? {});
  return o(e ?? n, a ?? {});
}, o = (e, i) => {
  if (!e)
    return;
  let n = e;
  return l(i, (a, s) => {
    n = n.replace(new RegExp("{" + s + "}", "g"), a);
  }), n;
}, N = (e) => u(e, (i, n) => n != "type"), x = (e) => (e == null ? void 0 : e.uid) && (e == null ? void 0 : e.product_type);
var w = /* @__PURE__ */ ((e) => (e.MODAL = "modal", e.HREF = "href", e.TERMS = "terms", e))(w || {}), O = /* @__PURE__ */ ((e) => (e.LINK = "link", e.CHECKBOX = "checkbox", e))(O || {});
const f = r("functions/page", r.COLOR_LIB), E = (e, i = !1) => {
  if (!e || typeof e != "object")
    throw new Error("Cannot normalize non-Page: " + typeof e);
  return (!e.data || typeof e.data != "object") && (e.data = y({
    uid: d("page-"),
    name: "",
    semantic: null,
    help_modal: null,
    validated: !1,
    errors: null,
    linked: []
  })), (!e.data.uid || typeof e.data.uid == "boolean") && (e.data.uid = d("page-")), typeof e.data.uid == "number" && (e.data.uid = String(e.data.uid)), (!c(e.data.validated) || i) && (e.data.validated = !1), c(e.data.semantic) && !Array.isArray(e.data.semantic) && (e.data.semantic = [String(e.data.semantic)]), Array.isArray(e.components) || (e.components = []), e.display_offices && (typeof e.display_offices == "object" ? Array.isArray(e.display_offices.offices) ? e.display_offices.mode !== "include" && e.display_offices.mode !== "exclude" && (e.display_offices.mode = m.INCLUDE) : (f.warnFrom("normalizePage", "Invalid display_offices.offices", e.display_offices), delete e.display_offices) : (f.warnFrom("normalizePage", "Invalid display_offices", e.display_offices), delete e.display_offices)), e.display_condition = e.display_condition ?? null, e.enabled = c(e.enabled) ? e.enabled : !0, e.guards && !Array.isArray(e.guards) && (e.guards = []), e;
}, D = (e, i = !1) => E(_(e), i), H = (e, i, n = "OR") => {
  if (!e.data.semantic)
    return !1;
  let a = typeof e.data.semantic == "string" ? [e.data.semantic] : e.data.semantic;
  return b(a, i, n);
}, g = r("functions/product", r.COLOR_HELPER), K = (e, i, n) => ({
  uid: e,
  product_id: i,
  product_type: n,
  selected: !1,
  selected_component_uid: null,
  terms_agreed: !1,
  children: null
}), A = (e) => e.product_id ? e.uid : e.origin_component_uid ? e.origin_component_uid + "-" + (e.product_type ?? "other") + "-" + e.uid : (e.product_type ?? "other") + "-" + e.uid, P = (e) => {
  if (!x(e))
    throw g.warn("Not a product", e), new Error("Cannot normalize non-Product: " + JSON.stringify(e, null, 4));
  let i = A(e), n = e.product_id ?? e.uid, a = e.children;
  if (Array.isArray(a) && a.length && S(a), e.uid = i, e.product_id = n, e.selected = e.selected || !1, e.selected_component_uid = e.selected_component_uid || null, e.terms_agreed = e.terms_agreed || !1, e.children = a, e.checkboxes) {
    if (!e.checkboxes_values)
      e.checkboxes_values = k(
        e.checkboxes,
        (s) => s.uid,
        (s) => !1
      );
    else
      for (let s of e.checkboxes)
        e.checkboxes_values[s.uid] = e.checkboxes_values[s.uid] ?? !1;
    for (let s of e.checkboxes)
      for (let t of s.actions)
        t.uid || (t.uid = d("action-"));
  } else
    e.checkboxes_values = {};
  return e;
}, S = (e) => {
  for (let i of e)
    P(i);
  return e;
};
export {
  w as P,
  D as a,
  P as b,
  K as c,
  S as d,
  I as e,
  h as f,
  A as g,
  v as h,
  L as i,
  R as j,
  z as k,
  C as l,
  N as m,
  E as n,
  x as o,
  H as p,
  O as q,
  o as r
};
//# sourceMappingURL=product-CdujHKtW.js.map
